import { BlackFridaySelectionDTO } from 'api-models'
import { CSSProperties, ReactNode, useEffect, useState } from 'react'
import { BlackFridayOffers } from 'services/user/black-friday-offer'
import { NewSubscriptionBanner } from './new-subscription-banner'

export const OnboardingOfferLayout = ({
	accountId,
	children
}: {
	accountId?: string
	children: ReactNode
}) => {
	const [offer, setOffer] = useState<{
		accountId?: string
		data: BlackFridaySelectionDTO
	} | null>(null)
	const [height, setHeight] = useState(0)
	const [expired, setExpired] = useState(false)

	useEffect(() => {
		let current = true
		const request = accountId
			? BlackFridayOffers.selection(accountId, true)
			: BlackFridayOffers.onboardingAvailability()
		void request
			.then((data) => {
				if (current) setOffer({ accountId, data })
			})
			.catch(() => {
				if (current) setOffer(null)
			})
		return () => {
			current = false
		}
	}, [accountId])

	useEffect(() => {
		if (!offer) return
		const deadline =
			performance.now() +
			Date.parse(offer.data.claim_deadline) -
			Date.parse(offer.data.server_now)
		let timer: ReturnType<typeof setTimeout>
		const checkExpiry = () => {
			const remaining = deadline - performance.now()
			setExpired(remaining <= 0)
			if (remaining > 0)
				timer = setTimeout(checkExpiry, Math.min(remaining + 1, 2147483647))
		}
		checkExpiry()
		return () => clearTimeout(timer)
	}, [offer])

	return (
		<div style={{ '--cg-top-banner-h': `${height}px` } as CSSProperties}>
			<div className="sticky top-0 z-[60]">
				<NewSubscriptionBanner
					open={
						offer?.accountId === accountId &&
						!!offer?.data.available &&
						!expired
					}
					onHeightChange={setHeight}
				/>
			</div>
			{children}
		</div>
	)
}
